// Cheat-sheet formulas (ported from Audit Genius)
export interface RoofM {
  totalSquares: number;
  eaveLF: number;
  rakeLF: number;
  ridgeLF: number;
  hipLF: number;
  valleyLF: number;
  pipeCount?: number;
  facetCount?: number;
  stories?: number;
  pitch?: string;
  deckingSheets?: number;
}
export const calcShingleBundles = (sq: number, w = 0.10) => Math.ceil((sq * w + sq) * 3);
export const calcRidgeCapBundles = (r: number, h: number, lfPerBdl = 25) => Math.ceil((r + h) / lfPerBdl);
export const calcIceWaterRolls = (m: RoofM) => {
  const step = (m.facetCount || 4) * 8;
  return Math.ceil((m.eaveLF * 3 + m.hipLF + m.valleyLF + m.rakeLF + step) / 66);
};
export const calcUnderlaymentRolls = (sq: number, sqPerRoll = 10) => Math.ceil(sq / sqPerRoll);
export const calcStarterBundles = (e: number, r: number, lfPerBdl = 100) => Math.ceil((e + r) / lfPerBdl);
export const calcCoilNailBoxes = (sq: number) => Math.max(1, Math.ceil(sq / 15));
export const calcCapNailBoxes = (sq: number) => Math.max(1, Math.ceil(sq / 30));
